import { Alert, Grid, Stack, Typography } from "@mui/material";

export default function AutoriaRecebimento({ ocorrencia: o }) {
  const autenticado = o.recebidoPorNome || o.recebidoPor || o.recebidoPorId;
  function campo(label, value, detalhe) {
    return (
      <Grid item xs={12} sm={6}>
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={600}
          sx={{ overflowWrap: "anywhere" }}
        >
          {value || "Não registrado"}
        </Typography>
        {detalhe && (
          <Typography variant="caption" color="text.secondary">
            {detalhe}
          </Typography>
        )}
      </Grid>
    );
  }
  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1" fontWeight={600}>
        Quem enviou ao conector
      </Typography>
      {!o.usuarioOrigem && (
        <Alert severity="info">
          {autenticado
            ? "A identidade da entrega está registrada. O responsável pela operação na Folha não foi informado nesta ocorrência."
            : "Esta ocorrência não possui autoria registrada no conector. O histórico da Folha é a fonte para identificar o responsável original."}
        </Alert>
      )}
      <Grid container spacing={2}>
        {campo(
          "Responsável informado pela origem",
          o.usuarioOrigem,
          o.usuarioOrigem ? "Autoria declarada pelo sistema de origem." : null
        )}
        {campo("Sistema de origem", o.sistemaOrigem)}
        {campo(
          "Identidade autenticada na entrega",
          autenticado,
          o.recebidoPorNome && o.recebidoPor ? o.recebidoPor : null
        )}
        {campo(
          "Cliente autenticado",
          o.clienteRecebimento,
          autenticado ? "Pode ser uma conta técnica da integração." : null
        )}
      </Grid>
      <Typography variant="body2" color="text.secondary">
        A autoria acima se refere ao recebimento da ocorrência. As tentativas
        abaixo mostram o processamento e a transmissão pelo conector.
      </Typography>
    </Stack>
  );
}
